import React, { useEffect, useRef, useState } from "react";
import { Table, Input, Card } from "antd";
import Service from "../../service"; // Ensure postMethod is defined here
import "./reward.css";
import "./karma.css";

const KarmaSummery = () => {
  const Search = Input.Search;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [search, setSearch] = useState("");
  const [seachEnabled, setSearchEnabled] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const searchRef = useRef();
  useEffect(() => {
    fetchData({ search: "", pagination });
  }, []);

  const onSearch = (value) => {
    setSearchText(value);
    setPagination({ ...pagination, current: 1 });
  };
  const fetchData = async ({ search = "", pagination }) => {
    setLoading(true);
    try {
      const payload = {
        search,
        pageNum: pagination.current,
        pageLimit: pagination.pageSize
      };

      const response = await Service.makeAPICall({
        methodName: Service.postMethod, // ✅ must be POST
        api_url: Service.getKarmaDetails,
        body: payload
      });

      const result = response.data || { data: [], metaData: {} };

      setData(result.data);
      setPagination({
        ...pagination,
        total: result.metaData?.totalFilteredCount || 0,
      });
    } catch (err) {
      console.error("Failed to fetch data:", err);
    }
    setLoading(false);
  };
  const resetSearchFilter = (e) => {
    const keyCode = e && e.keyCode ? e.keyCode : e;
    switch (keyCode) {
      case 8:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      case 46:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      default:
        break;
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    fetchData({ search: value, pagination: { ...pagination, current: 1 } });
  };

  const handleTableChange = (pag) => {
    fetchData({ search, pagination: pag });
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "emp_code",
      key: "emp_code",
    },
    {
      title: "Emp Name",
      dataIndex: "full_name",
      key: "full_name",
    },
    {
      title: "Remaining Waffle",
      dataIndex: "karma_balance",
      key: "karma_balance",
      render: (value) => {
        if (value == 0 || !value) return "0";
        if (value === -1) return "Unlimited";
        return value;
      }
    },
    {
      title: "Received Waffle",
      dataIndex: "total_received_karma",
      key: "total_received_karma",
      render: (value) => {
        if (value == 0) return "0";
        return value;
      }
    },
    {
      title: "Monthly Waffle",
      dataIndex: "karma_sending_balance",
      key: "karma_sending_balance",
      render: (value) => {
        if (value == 0 || !value) return "0";
        if (value === -1) return "Unlimited";
        return value;
      }
    }

    // {
    //   title: "Remaining Waffle",
    //   dataIndex: "karma_balance",
    //   key: "karma_balance",
    // },
    // {
    //   title: "Received Waffle",
    //   dataIndex: "total_received_karma",
    //   key: "total_received_karma",
    // },

    // {
    //     title: "Monthly Waffle",
    //     dataIndex: "karma_sending_balance",
    //     key: "karma_sending_balance",
    //   },

  ];

  return (
    <Card className="employee-card">
      <div className=" inout-header text-left">
        <h2> Employee Waffle Balance Dashboard</h2>

      </div>

      <Card className="main-content-wrapper" >

        <div className="waffle-dashboard">
          <div className="search-wrapper">
            {/* <Input.Search
          placeholder="Search by Emp. Name"
          value={ search }
          onChange={ handleSearch }
          enterButton
          style={ { width: 300, marginBottom: 16 } }
        /> */}
            <Search
              ref={ searchRef }
              placeholder="Search..."
              onSearch={ onSearch }
              onKeyUp={ resetSearchFilter }
              style={ { width: 200 } }
              className="mr2"
            />

          </div>
          <div className="main-table-wrapper">

            <Table
              columns={ columns }
              dataSource={ data }
              loading={ loading }
              rowKey="_id"
              pagination={ pagination }
              footer={ () => `Total employee ${pagination?.total}` }
              onChange={ handleTableChange }
              bordered
            />
          </div>
        </div>
      </Card>
    </Card>
  );
};

export default KarmaSummery;
